import React from "react";

import { Link } from "react-router-dom";
import { getLocalMatchTime } from "../../utils/matchTimeConverter";

const IPLMatchCardLive = ({
    match,
}) => {

    // ============================
    // FORMAT DATE
    // ============================
    const formatDate = (
        date,
        time
    ) => {

        if (!date) return "";

        const fullDate =
            new Date(
                `${date} ${time}`
            );

        return fullDate.toLocaleString(
            "en-IN",
            {
                day: "numeric",
                month: "short",
                year: "numeric",
                hour: "numeric",
                minute: "2-digit",
            }
        );
    };

    // ============================
    // MATCH STATUS
    // ============================
    const isLive =
        match?.match_live ===
        "1";
const result =
    getLocalMatchTime({
      country: match?.country_name,
      matchDate: match?.match_date,
      matchTime: match?.match_time,
    });
    return (

        <Link
            to={`/match/${match?.match_id}`}
        >

            <div
                className="
                relative
                overflow-hidden
                rounded-2xl
                cursor-pointer
                group
                transition-all
                duration-300
                "
            >

                {/* CARD */}

                <div
                    className="
                    relative
                    bg-white
                    dark:bg-[#121212]
                    border
                    border-gray-200
                    dark:border-gray-700
                    rounded-2xl
                    overflow-hidden
                    shadow-md
                    group-hover:shadow-xl
                    transition-all
                    "
                >

                    {/* HOVER EFFECT */}

                    <div
                        className="
                        absolute
                        inset-0
                        opacity-0
                        group-hover:opacity-100
                        transition-opacity
                        duration-500
                        bg-gradient-to-br
                        from-blue-500/10
                        via-transparent
                        to-orange-500/10
                        pointer-events-none
                        "
                    />

                    {/* TOP BAR */}

                    <div
                        className="
                        h-1
                        w-full
                        bg-gradient-to-r
                        from-yellow-500
                        via-orange-500
                        to-red-500
                        "
                    />

                    {/* LEAGUE LOGO */}

                    <div
                        className="
                        absolute
                        top-3
                        right-3
                        z-10
                        "
                    >

                        <div
                            className="
                            w-10
                            h-10
                            rounded-xl
                            bg-white
                            dark:bg-[#1e1e1e]
                            border
                            border-gray-300
                            dark:border-gray-600
                            shadow
                            flex
                            items-center
                            justify-center
                            "
                        >

                            <img
                                src={
                                    match?.league_logo
                                }
                                alt=""
                                className="
                                w-8
                                h-8
                                object-contain
                                "
                            />

                        </div>

                    </div>

                    <div className="p-4">

                        {/* TAGS */}

                        <div
                            className="
                            flex
                            items-center
                            justify-center
                            gap-2
                            mb-2
                            "
                        >

                            <span
                                className="
                                bg-red-600
                                text-white
                                text-xs
                                font-bold
                                px-3
                                py-1
                                rounded-full
                                "
                            >

                                LIVE

                            </span>

                            <span
                                className="
                                bg-gradient-to-r
                                from-amber-500
                                to-orange-600
                                text-white
                                text-xs
                                font-bold
                                px-3
                                py-1
                                rounded-full
                                "
                            >

                                Round{" "}
                                {
                                    match?.match_round
                                }

                            </span>

                        </div>

                        {/* LEAGUE */}

                        <div className="text-center mb-3">

                            <h3
                                className="
                                text-base
                                md:text-lg
                                font-semibold
                                text-gray-900
                                dark:text-white
                                "
                            >

                                {
                                    match?.league_name
                                }

                            </h3>

                            <div
                                className="
                                flex
                                items-center
                                justify-center
                                gap-2
                                mt-1
                                "
                            >

                                <div
                                    className="
                                    h-px
                                    w-8
                                    bg-gradient-to-r
                                    from-transparent
                                    to-blue-500
                                    "
                                />

                                <span
                                    className="
                                    text-xs
                                    text-blue-500
                                    font-semibold
                                    "
                                >

                                    {
                                        match?.league_year
                                    }

                                </span>

                                <div
                                    className="
                                    h-px
                                    w-8
                                    bg-gradient-to-l
                                    from-transparent
                                    to-blue-500
                                    "
                                />

                            </div>

                        </div>

                        {/* COUNTRY + STATUS */}

                        <div
                            className="
                            flex
                            items-center
                            justify-between
                            mb-3
                            "
                        >

                            <span
                                className="
                                text-xs
                                font-semibold
                                px-3
                                py-1
                                rounded-full
                                border
                                border-blue-500/30
                                text-blue-500
                                bg-blue-500/10
                                "
                            >

                                ⚽ Football

                            </span>

                            <div
                                className="
                                flex
                                items-center
                                gap-2
                                "
                            >

                                <span className="text-yellow-500">
                                    ⭐
                                </span>

                                <span
                                    className="
                                    text-xs
                                    bg-gray-100
                                    dark:bg-gray-800
                                    text-gray-600
                                    dark:text-gray-300
                                    px-3
                                    py-1
                                    rounded-full
                                    "
                                >

                                    {
                                        match?.country_name
                                    }

                                </span>

                            </div>

                        </div>

                        {/* TEAMS */}

                        <div
                            className="
                            flex
                            items-center
                            justify-between
                            gap-2
                            "
                        >

                            {/* HOME */}

                            <div
                                className="
                                flex-1
                                flex
                                flex-col
                                items-center
                                text-center
                                gap-1.5
                                "
                            >

                                <div
                                    className="
                                    w-14
                                    h-14
                                    md:w-16
                                    md:h-16
                                    p-2
                                    border
                                    border-gray-200
                                    dark:border-gray-700
                                    rounded-xl
                                    bg-white
                                    dark:bg-[#1e1e1e]
                                    "
                                >

                                    <img
                                        src={
                                            match?.team_home_badge
                                        }
                                        className="
                                        w-full
                                        h-full
                                        object-contain
                                        "
                                        alt=""
                                    />

                                </div>

                                <p
                                    className="
                                    text-xs
                                    md:text-sm
                                    text-gray-700
                                    dark:text-gray-300
                                    font-medium
                                    "
                                >

                                    {
                                        match?.match_hometeam_name
                                    }

                                </p>

                                <span
                                    className="
                                    text-2xl
                                    font-black
                                    text-blue-500
                                    "
                                >

                                    {
                                        match?.match_hometeam_score
                                    }

                                </span>

                            </div>

                            {/* VS */}

                            <div
                                className="
                                flex
                                flex-col
                                items-center
                                "
                            >

                                <div
                                    className="
                                    w-10
                                    h-10
                                    rounded-full
                                    bg-gradient-to-br
                                    from-blue-500/20
                                    to-orange-500/20
                                    border
                                    border-gray-300
                                    dark:border-gray-700
                                    flex
                                    items-center
                                    justify-center
                                    "
                                >

                                    <span
                                        className="
                                        text-xs
                                        font-bold
                                        text-gray-700
                                        dark:text-gray-300
                                        "
                                    >

                                        VS

                                    </span>

                                </div>

                                {isLive && (

                                    <span
                                        className="
                                        mt-2
                                        inline-flex
                                        items-center
                                        gap-1
                                        text-[10px]
                                        bg-red-500/20
                                        text-red-500
                                        px-2
                                        py-1
                                        rounded-full
                                        animate-pulse
                                        "
                                    >

                                        <span
                                            className="
                                            w-2
                                            h-2
                                            bg-red-500
                                            rounded-full
                                            "
                                        />

                                        LIVE

                                    </span>
                                )}

                            </div>

                            {/* AWAY */}

                            <div
                                className="
                                flex-1
                                flex
                                flex-col
                                items-center
                                text-center
                                gap-1.5
                                "
                            >

                                <div
                                    className="
                                    w-14
                                    h-14
                                    md:w-16
                                    md:h-16
                                    p-2
                                    border
                                    border-gray-200
                                    dark:border-gray-700
                                    rounded-xl
                                    bg-white
                                    dark:bg-[#1e1e1e]
                                    "
                                >

                                    <img
                                        src={
                                            match?.team_away_badge
                                        }
                                        className="
                                        w-full
                                        h-full
                                        object-contain
                                        "
                                        alt=""
                                    />

                                </div>

                                <p
                                    className="
                                    text-xs
                                    md:text-sm
                                    text-gray-700
                                    dark:text-gray-300
                                    font-medium
                                    "
                                >

                                    {
                                        match?.match_awayteam_name
                                    }

                                </p>

                                <span
                                    className="
                                    text-2xl
                                    font-black
                                    text-blue-500
                                    "
                                >

                                    {
                                        match?.match_awayteam_score
                                    }

                                </span>

                            </div>

                        </div>

                        {/* MATCH INFO */}

                        <div
                            className="
                            mt-3
                            pt-2
                            border-t
                            border-gray-200
                            dark:border-gray-700
                            text-center
                            text-xs
                            text-gray-600
                            dark:text-gray-400
                            space-y-1
                            "
                        >

                            <p>

                                🏆{" "}

                                <span
                                    className="
                                    text-gray-900
                                    dark:text-white
                                    font-medium
                                    "
                                >

                                    {
                                        match?.stage_name
                                    }

                                </span>

                            </p>

                            <p>

                                📅{" "}

                                {
                                    formatDate(
                                        result.localDate,
                                        result.localTime
                                    )
                                }

                            </p>

                            {match?.match_stadium && (

                                <p>

                                    📍{" "}

                                    {
                                        match?.match_stadium
                                    }

                                </p>
                            )}

                        </div>

                    </div>

                    {/* HOVER ICON */}

                    <div
                        className="
                        absolute
                        bottom-4
                        right-4
                        opacity-0
                        group-hover:opacity-100
                        transform
                        translate-x-2
                        group-hover:translate-x-0
                        transition-all
                        "
                    >

                        <div
                            className="
                            w-8
                            h-8
                            bg-blue-500/20
                            border
                            border-blue-500/30
                            rounded-full
                            flex
                            items-center
                            justify-center
                            "
                        >

                            ➜

                        </div>

                    </div>

                </div>

            </div>

        </Link>
    );
};

export default IPLMatchCardLive;